import React from 'react';
import PropTypes from 'prop-types';

const LazyLoadSource = ({ srcSet, media }) => {
  const supportsLoading = navigator.userAgent !== 'ReactSnap' && 'loading' in HTMLImageElement.prototype;

  return (
    <source
      media={media}
      srcSet={supportsLoading ? srcSet : null}
      data-srcset={!supportsLoading ? srcSet : null}
    />
  );
};

LazyLoadSource.propTypes = {
  media: PropTypes.string.isRequired,
  srcSet: PropTypes.string.isRequired,
};

export { LazyLoadSource };
